import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { getUserId } from '../../helpers/auth'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { Button, Image, Input, Modal } from 'antd'
import Loader from '../../pages/pages/loader'
import {
  useCreateIptvReportMutation,
  useUpdateIptvReportMutation
} from '../../redux/apis/linkManagement/iptv/reports/lmIptvReportsApiSlice'
import IptvAppDropdown from '../IptvAppDropdown'

const EditCreateIptvReport = ({ state, open, setOpen, record }) => {
  const [file, setFile] = useState(null)
  const [preview, setPreview] = useState('')
  const [
    updateReport,
    { isLoading: isUpdating, isSuccess: SuccessUpdate, error: errorUpdate }
  ] = useUpdateIptvReportMutation()
  const [
    addReport,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useCreateIptvReportMutation()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      subject: record?.subject,
      attachment: record?.attachment,
      iptv: record?.iptv?.id,
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({}),

    onSubmit: async values => {
      const formData = new FormData()
      for (let key in values) {
        formData.append(key, values[key])
      }
      if (file) {
        formData.append('attachment', file)
      }
      try {
        if (state === 'edit') {
          await updateReport({
            body: formData,
            id: record?.id
          }).unwrap()
        } else if (state === 'create') {
          await addReport(formData).unwrap()
        }
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (!file) {
      return
    }
    const objectUrl = URL.createObjectURL(file)
    setPreview(objectUrl)
    return () => URL.revokeObjectURL(objectUrl)
  }, [file])

  useEffect(() => {
    if (errorAdd?.data) {
      const errorMessages = Object.values(errorAdd.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (errorUpdate?.data) {
      const errorMessages = Object.values(errorUpdate.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorAdd, errorUpdate])

  useEffect(() => {
    console.log(SuccessAdd, SuccessUpdate)
    if (SuccessAdd && state === 'create') {
      toast.success('IPTV Report created successfully!')
      setOpen(false)
    } else if (SuccessUpdate && state === 'edit') {
      toast.success('IPTV Report successfully!')
      setOpen(false)
    }
  }, [state, SuccessAdd, SuccessUpdate])

  return (
    <Modal
      className='customModal'
      open={open}
      title={state === 'edit' ? `Edit IPTV Report` : 'Create IPTV Report'}
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding || isUpdating} />
      <div className=' mb-3'>
        <label className="form-label">Subject</label>
        <Input
          type='text'
          name='subject'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.subject}
        />
        {validation.touched.subject && validation.errors.subject ? (
          <p className='text-danger'>{validation.errors.subject}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <IptvAppDropdown
          onChange={e => {
            validation.setFieldValue('iptv', e)
          }}
          value={validation.values.iptv}
          onBlur={validation.handleBlur}
        />
        {validation.touched.iptv_id && validation.errors.iptv_id ? (
          <p className='text-danger'>{validation.errors.iptv_id}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">Upload File</label>
        <div className='flex gap-4 customInput'>
          <Input
            type='file'
            onChange={e => setFile(e.target.files[0])}
            accept='.png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .csv'
            style={{ height: '40px' }}
          />
          <Image
            className='border-1'
            style={{ width: '200px' }}
            src={preview ? preview : validation?.values?.attachment}
          />
        </div>
      </div>
    </Modal>
  )
}

export default EditCreateIptvReport
